const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
};

export const formatDate = (dateString: string, passedOptions?: Intl.DateTimeFormatOptions) => {
  const date = new Date(dateString);
  return date.toLocaleString('en-US', passedOptions ? passedOptions : options);
};

export const getFormattedDBTimestamp = () => {
  const date = new Date();
  const pad = (num: number, size: number) => ('000' + num).slice(size * -1);

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1, 2);
  const day = pad(date.getUTCDate(), 2);
  const hours = pad(date.getUTCHours(), 2);
  const minutes = pad(date.getUTCMinutes(), 2);
  const seconds = pad(date.getUTCSeconds(), 2);
  const milliseconds = pad(date.getUTCMilliseconds(), 3);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}+00`;
};
